<template>
  <div>
    <Header modeType="1" />
    <div class="content-center">
      <div class="banner">
        <div class="content">
          <div class="banner-title">千橙数字人 AI创作平台</div>
          <div class="line" />
          <div class="desc">
            千橙数字人是一款基于人工智能和计算机图形学技术，通过模拟还原真人外貌、声音和行为的AI数字分身。使用千橙数字人来进行发布，也可以定制自己的专属数字员工进行品牌推广。
            <!-- <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div> -->
          </div>
          <div class="btn-wrap">
            <div
                class="btn1"
                @click="openLoginModal"
              >免费试用</div>
            <div class="btn" @click="openModal">立即咨询</div>
          </div>
        </div>
      </div>
      
      <div class="improve1 " style="height:393px;">
          <div class="sk-block-title1">
              <div class="title1"><span style="color: #4851fe;">4</span>大核心优势，提高运营效率和服务质量</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content1">
  
          </div>
      </div>
      <div class="improve" style="height:960px;">
          <div class="sk-block-title1">
              <div class="title1">仅需4步，高效完成短视频创作</div>
          </div>
          <div class="content1">
  
          </div>
      </div>
      
      <div class="improve1 " style="height:1028px;">
          <div class="sk-block-title1">
              <div class="title1">定制数字人&音色，或使用系统提供的数字人&音色，满足不同场景需求</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content2">
  
          </div>
      </div>
      <div class="improve" style="height:764px;">
          <div class="content2">
  
          </div>
      </div>
      <div class="improve1 " style="height:662px;">
          <div class="content3">
  
          </div>
      </div>
      <div class="improve" style="height:662px;">
          <div class="content3">
  
          </div>
      </div>
      <Contact :infoSources="'千橙数字人'" />
      <TryModal
        v-if="visible"
        :visible="visible"
        info-sources="社群分销"
        @cancel="modalClose"
      />
      <LoginModal
            v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'10'"
        />
    </div>
    <Footer />
  </div>
  </template>
  
  <script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import metaInfo from "@/common/util/metaInfo";
  import TryModal from "@/components/TryModal";
  import Contact from "@/components/Contact";
  import LoginModal from '@/components/LoginModal'

  export default {
    metaInfo: metaInfo.QcDigit,
    components: {
      Header,
      Footer,
      TryModal,
      Contact,
    LoginModal
    },
    data() {
      return {
        visible: false,
        toolBg: require("@/assets/images/QcCashier/tool1.png"),
        tooItem: "1",
        showLogin:false,//是否展示注册弹框
      isLogin:false,//是否注册
      };
    },
    mounted() {},
    methods: {
        // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
      checkBg(item) {
        this.tooItem = item;
        this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
      },
      openModal: function () {
        this.visible = true;
      },
      modalClose: function (data) {
        this.visible = data;
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .programme{
        height:745px;
        background: #202239;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content{
          margin-top:140px;
          width: 1200px;
          height:445px;
          background: url("~@/assets/images/QcB2BChannel/content4.png") no-repeat center;
          background-size: 1200px 445px;
      }
  }
  .improve1{
    background: #F8FCFF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content1{
          margin-top:31px;
          width: 1200px;
          height:192px;
          background: url("~@/assets/images/QcDigit/content1.png") no-repeat  center;
          background-size: 994px 192px;
      }
      .content2{
          margin-top:54px;
          width: 1200px;
          height:806px;
          background: url("~@/assets/images/QcDigit/content3.png") no-repeat center;
          background-size: 1200px 806px;
      }
      .content3{
          margin-top:80px;
          width: 1200px;
          height:502px;
          background: url("~@/assets/images/QcDigit/content5.png") no-repeat center;
          background-size: 1200px 502px;
      }
  }
  .improve{
      display: flex;
      flex-direction: column;
      // justify-content: center;
        background: #FFFFFF;
      align-items:center;
      .content1{
          margin-top:50px;
          width: 1270px;
          height:736px;
          background: url("~@/assets/images/QcDigit/content2.png") no-repeat center;
          background-size: 1270px 736px;
      }
      .content2{
          margin-top:57px;
          width: 1200px;
          height:525px;
          background: url("~@/assets/images/QcDigit/content4.png") no-repeat center;
          background-size: 1200px 525px;
      }
      .content3{
          margin-top:80px;
          width: 1200px;
          height:504px;
          background: url("~@/assets/images/QcDigit/content6.png") no-repeat center;
          background-size: 1200px 504px;
      }
  }
  
  /deep/ i.el-icon-arrow-left {
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ i.el-icon-arrow-right{
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  
  .custom{
          height:662px;
          background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          // justify-content: center;
          align-items:center;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          text-align: left;
          background: rgba(255,255,255,.5);
          // background: #FFFFFF;
          // opacity: 0.55;
          // border-radius: 8px;
          margin-top: 42px;
          height:439px;
          .custom_item{
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              padding:0 150px;
              .cutom_box{
                  width:260px;
                  height:89px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  margin-top:140px;
                  .box_item{
                      display: flex;
                      flex-direction: column;
                      .box_title{
                          width: 71px;
                          height: 45px;
                          font-size: 32px;
                          font-family: PingFangSC, PingFang SC;
                          font-weight: 600;
                          color: #333333;
                          line-height: 45px;
                      }
                      .box_line{
                          width: 43px;
                          height: 5px;
                          background: #3986FF;
                      }
                      .box_span{
                          width: 96px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #595961;
  line-height: 22px;
                      }
                  }
              }
              .custom_item_text{
                  margin-left: 50px;
                  .title{
                      height: 40px;
                      font-size: 22px;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 600;
                      color: #333333;
                      line-height: 40px;
                  }
                  .text{
                      height: 20px;
                      font-size: 16px;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 500;
                      color: #333333;
                      line-height: 20px;
                      margin-top:30px;
                  }
              }
              img{
                  width: 438px;
                  height: 302px;
              }
          }
      }
  }
  .case{
      background: #F8FBFF;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              width: 1171px;
              height:397px;
          }
      }
  }
  
    .banner {
      background: url("~@/assets/images/QcB2BChannel/banner.png") no-repeat center;
      background-size: 100% 100%;
      min-width: 1200px;
      min-height:420px;
      .content {
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        text-align: left;
        .banner-title {
          font-size: 48px;
          color: #FFFFFF;
          line-height: 55px;
        }
        .line {
          width: 100px;
          height: 6px;
          background: #28DAFB;
          margin: 16px 0 31px;
        }
        .desc {
            width: 484px;
            height: 84px;
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 28px;
          .desc-content{
              width: 600px;
              height: 96px;
              font-size: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
          }
        }
        .btn-wrap {
          display: flex;
          .btn {
            width: 200px;
            height: 58px;
            line-height: 58px;
            border-radius: 6px;
            border: 1px solid #FFFFFF;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
            margin-left:20px;
          }
          .btn1 {
            width: 200px;
            height: 58px;
            line-height: 58px;
            background: #3986FF;
            border-radius: 6px;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
          //   margin-left:20px;
          }
        }
      
    }
  
  }
  </style>
  